module.exports = __webpack_public_path__ + "static/media/posca.47bed49e.png";